const DUIL_CUSTOM_ELEMENT_PREFIX = 'duil310-dhl';

export const DUIL_TAGS = {
    alert: `${DUIL_CUSTOM_ELEMENT_PREFIX}-alert`,
    autocompleteField: `${DUIL_CUSTOM_ELEMENT_PREFIX}-autocomplete-field`,
    button: `${DUIL_CUSTOM_ELEMENT_PREFIX}-button`,
    card: `${DUIL_CUSTOM_ELEMENT_PREFIX}-card`,
    checkbox: `${DUIL_CUSTOM_ELEMENT_PREFIX}-checkbox`,
    counter: `${DUIL_CUSTOM_ELEMENT_PREFIX}-counter`,
    datePicker: `${DUIL_CUSTOM_ELEMENT_PREFIX}-date-picker`,
    dropdown: `${DUIL_CUSTOM_ELEMENT_PREFIX}-dropdown`,
    inputAddon: `${DUIL_CUSTOM_ELEMENT_PREFIX}-input-addon`,
    inputField: `${DUIL_CUSTOM_ELEMENT_PREFIX}-input-field`,
    inputGroup: `${DUIL_CUSTOM_ELEMENT_PREFIX}-input-group`,
    modal: `${DUIL_CUSTOM_ELEMENT_PREFIX}-modal`,
    popover: `${DUIL_CUSTOM_ELEMENT_PREFIX}-popover`,
    radioButtonGroup: `${DUIL_CUSTOM_ELEMENT_PREFIX}-radio-button-group`,
    select: `${DUIL_CUSTOM_ELEMENT_PREFIX}-select`,
    textAreaField: `${DUIL_CUSTOM_ELEMENT_PREFIX}-text-area-field`,
} as const;
